import React, { useEffect, useLayoutEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Invest from "../pages/Invest";
import Faq from "../pages/others/Faq";
import Regularv1 from "../pages/others/Regular-1";
import Regularv2 from "../pages/others/Regular-2";
import Terms from "../pages/others/Terms";
import UserProfileRegular from "../pages/pre-built/user-manage/UserProfileRegular";
import UserProfileSetting from "../pages/pre-built/user-manage/UserProfileSetting";
import UserProfileNotification from "../pages/pre-built/user-manage/UserProfileNotification";
import UserProfileActivity from "../pages/pre-built/user-manage/UserProfileActivity";

import Error404Modern from "../pages/error/404-modern";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import Success from "../pages/auth/Success";
import ResetPassword from "../pages/auth/ResetPassword";
import SuccessMain from "../pages/auth/SuccessMain";

import Layout from "../layout/Index";
import LayoutNoSidebar from "../layout/Index-nosidebar";

//Procurex Pages

import InvoicePayables from "../pages/payments/invoicePayables";
import PendingPaymentApprovals from "../pages/payments/pendingPaymentApprovals";
import RunPayments from "../pages/payments/runPayments";
import ViewPayments from "../pages/payments/viewPayments";
import ViewReceivables from "../pages/payments/viewReceivables";
import CreatePayment from "../pages/payments/CreatePayment";
import CreateReceivable from "../pages/payments/CreateReceivable";
import { useDispatch } from "react-redux";
import { fetchCurrentUser } from "../store/slices/misc/currentUser";

import PaymentsAnalytics from "../pages/payments/PaymentsAnalytics";
import ReleaseRetentionList from "../pages/payments/ReleaseRetentionList";
import ReleaseRetentionForm from "../pages/payments/ReleaseRetentionForm";
import ReleaseOnHoldList from "../pages/payments/ReleaseOnHoldList";
import ReleaseOnHoldForm from "../pages/payments/ReleaseOnHoldForm";
import { useSelector } from "react-redux";
import { updateAccessibility } from "../store/slices/misc/accessibility";
import { updateMenuData } from "../store/slices/misc/menuData";
import { Flex, Spin } from "antd";
import { updateAllowedRoutes } from "../store/slices/misc/allowedRoutes";
import { fetchSequenceAccess } from "../store/slices/misc/sequenceAccess";
import Cookies from "js-cookie";
import WorkBoqCreationMain from "../pages/work-boq/workBoqCreationMain";
import WorkBoqList from "../pages/work-boq/workBoqList";
import WorkBoqApprovals from "../pages/work-boq/workBoqApprovals";
import WorkBoqView from "../pages/work-boq/workBoqView";
import ExcelExportRequestedList from "../pages/pre-built/user-manage/ExcelExportRequestedList";
import NotificationMain from "../pages/notifications/NotificationMain";
import BulkUploadList from "../pages/pre-built/user-manage/ExcelUploadRequestedList";
import DefaultDashboardPage from "../pages/DefaultDashboard";
import { HomeOutlined } from "@ant-design/icons";
import WorkRequestList from "../pages/work-requests/workRequestList";
import WorkRequestCreationMain from "../pages/work-requests/workRequestCreationMain";
import WorkRequestApprovals from "../pages/work-requests/workRequestApprovals";
import WorkRequestView from "../pages/work-requests/workRequestView";
import WorkOrderCreationMain from "../pages/work-orders/workOrderCreationMain";
import ViewWorkOrder from "../pages/work-orders/ViewWorkOrder";
import WorkOrderView from "../pages/work-orders/workOrderView";
import PendingWorkOrderApprovals from "../pages/work-orders/PendingWorkOrderApprovals";
import UnderWorkExecution from "../pages/work-executions/UnderWorkExecution";
import PendingExecutionApprovals from "../pages/work-executions/PendingExecutionApprovals";
import ClosedWorks from "../pages/work-executions/ClosedWorks";
import WorkExecutionView from "../pages/work-executions/WorkExecutionView";
import WorkOrderAmendments from "../pages/work-orders/WorkOrderAmendments";
import FinalizedWorkOrders from "../pages/work-orders/FinalizedWorkOrders";
import CreateRABills from "../pages/ra-bills/CreateRABills";
import CreateRABillDetails from "../pages/ra-bills/CreateRABillDetails";
import RABillsPendingApprovals from "../pages/ra-bills/RABillsPendingApprovals";
import ViewRABillsApproved from "../pages/ra-bills/ViewRABillsApproved";
import RABillsOutstanding from "../pages/ra-bills/RABillsOutstanding";
import RABillsOverdue from "../pages/ra-bills/RABillsOverdue";
import RABillDetails from "../pages/ra-bills/RABillDetails";
import WorkOrderReportsContainer from "../pages/work-order-reports/WorkOrderReportsContainer";
import ReportView from "../pages/work-order-reports/ReportView";
import ContractorLedger from "../pages/work-order-reports/ContractorLedger";
import WorkExecutionBatchDetails from "../pages/work-executions/WorkExecutionBatchDetails";
import WorkExecutionUpdate from "../pages/work-executions/WorkExecutionUpdate";
import WorkExecutionHold from "../pages/work-executions/WorkExecutionHold";
import WorkExecutionRelease from "../pages/work-executions/WorkExecutionRelease";
import WorkOrderRiskflags from "../pages/work-orders/WorkOrderRiskflags";
import WorkOrderAdvance from "../pages/work-orders/WorkOrderAdvance";
import ImportsList from "../pages/imports/ImportsList";
const globalRoutes = [
  "/",
  "/auth-reset",
  "/auth-success",
  "/auth-register",
  "/setPassword",
  "/success",
  "/errorEmail",
  "/privacy",
  // "/notifications",
];
const routesMap = {
  dashboard: <Invest />,
  "invoice-payables": <InvoicePayables />,
  "create-payment": <CreatePayment />,
  "pending-payment-approvals": <PendingPaymentApprovals />,
  "run-payments": <RunPayments />,
  "view-payments": <ViewPayments />,
  "view-receivables": <ViewReceivables />,
  "create-receivable": <CreateReceivable />,
  "payment-analytics": <PaymentsAnalytics />,
  "payments-analytics": <PaymentsAnalytics />,
  "release-retention": <ReleaseRetentionList />,
  "release-retention-form": <ReleaseRetentionForm />,
  "release-on-hold": <ReleaseOnHoldList />,
  "release-on-hold-form": <ReleaseOnHoldForm />,
  "terms-policy": <Terms />,
  faq: <Faq />,
  privacy: <Faq />,
  "pages/regular-v1": <Regularv1 />,
  "pages/regular-v2": <Regularv2 />,
  "work-boq-creation": <WorkBoqCreationMain />,
  "work-request-creation": <WorkRequestCreationMain />,
  "work-boq-list": <WorkBoqList />,
  "work-request-list": <WorkRequestList />,
  "work-boq-approvals": <WorkBoqApprovals />,
  "work-request-approvals": <WorkRequestApprovals />,
  "work-boq-view/:id": <WorkBoqView />,
  "work-request-view/:id": <WorkRequestView />,
  "work-order-creation": <WorkOrderCreationMain />,
  "view-work-orders": <ViewWorkOrder />,
  "work-order-view/:id": <WorkOrderView />,
  "work-order-approvals": <PendingWorkOrderApprovals />,
  "Finalized-Work-Orders": <FinalizedWorkOrders />,
  "work-order-contractor-approvals": <WorkOrderAmendments />,
  "work-execution-under-execution": <UnderWorkExecution />,
  "work-execution-pending-approvals": <PendingExecutionApprovals />,
  "work-execution-closed-works": <ClosedWorks />,
  "work-execution-view/:id": <WorkExecutionView />,
  "work-execution-batch-details/:id": <WorkExecutionBatchDetails />,
  "work-execution-update/:workOrderId": <WorkExecutionUpdate />,
  "work-execution-hold/:workOrderId": <WorkExecutionHold />,
  "work-execution-release/:workOrderId": <WorkExecutionRelease />,
  "work-order-riskflags/:id": <WorkOrderRiskflags />,
  "work-order-advance/:id": <WorkOrderAdvance />,
  "ra-bills-create": <CreateRABills />,
  "ra-bills-create-detail/:woId": <CreateRABillDetails />,
  "ra-bills-pending-approvals": <RABillsPendingApprovals />,
  "ra-bills-view-approved": <ViewRABillsApproved />,
  "ra-bills-outstanding": <RABillsOutstanding />,
  "ra-bills-overdue": <RABillsOverdue />,
  "ra-bills-view-details/:id": <RABillDetails />,
  "ra-bills-approval-details/:id": <RABillDetails />,
  "work-order-reports": <WorkOrderReportsContainer />,
  "work-order-reports/contractor-ledger": <ContractorLedger />,
  "work-order-reports/:reportId": <ReportView />,
  "imports-list": <ImportsList />,
  "*": <Error404Modern />,
};
const menu = [
  {
    text: "Dashboard",
    link: "dashboard",
  },
  // {
  //   text: "Budget",
  //   link: "view-budget",
  // },
  {
    text: "BOQ",
    link: "work-boq-list",
  },
  {
    text: "Work Request",
    link: "work-request-list",
  },
  {
    text: "Work Order",
    link: "view-work-orders",
  },
  {
    text: "Work Execution",
    link: "work-execution-under-execution",
  },
  {
    text: "RA Bills",
    link: "ra-bills-pending-approvals",
  },
  {
    text: "Payments & Receivables",
    subMenu: [
      {
        text: "Client Receivables",
        link: "view-receivables",
      },
      {
        text: "Contractor Payments",
        link: "view-payments",
      },
    ],
  },
  // {
  //   text: "Imports",
  //   link: "imports-list",
  // },
  {
    text: "Reports",
    link: "work-order-reports",
  },
];
const Pages = ({ setIsLoggedIn }) => {
  const { data: currentUser } = useSelector((state) => state.currentUser);
  const [accessibility, setAccessibility] = useState([]);
  const [restrictedRoutes, setRestrictedRoutes] = useState([]);
  const dispatch = useDispatch();
  const location = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const isAuthenticated = Cookies.get("access-token");
    if (
      !currentUser &&
      isAuthenticated &&
      !globalRoutes?.includes(window.location.pathname)
    ) {
      dispatch(fetchCurrentUser());
    }
  }, [dispatch]);

  useEffect(() => {
    if (currentUser?.userRoutePermissions) {
      try {
        dispatch(fetchSequenceAccess());
        const { userRoutePermissions } = currentUser;
        // const decodedString = atob(userRoutePermissions);
        const decodedString = {
          KYC: {
            menuItem: "KYC",
            access: true,
            routes: [
              { path: "kyc-list-regular", permission: true, pageType: "view" },
              {
                path: "kyc-details-regular/:kycId",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Pages: {
            menuItem: "Pages",
            access: true,
            routes: [
              { path: "terms-policy", permission: true, pageType: "view" },
              { path: "faq", permission: true, pageType: "view" },
              { path: "regular-v1", permission: true, pageType: "view" },
              { path: "regular-v2", permission: true, pageType: "view" },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Authentication: {
            menuItem: "Authentication",
            access: true,
            routes: [
              { path: "auth-success", permission: true, pageType: "view" },
              { path: "auth-reset", permission: true, pageType: "view" },
              { path: "auth-register", permission: true, pageType: "add" },
              { path: "setPassword", permission: true, pageType: "add" },
              { path: "success", permission: true, pageType: "view" },
              { path: "errorEmail", permission: true, pageType: "view" },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Errors: {
            menuItem: "Errors",
            access: true,
            routes: [
              { path: "errors/404-modern", permission: true, pageType: "view" },
              {
                path: "errors/404-classic",
                permission: true,
                pageType: "view",
              },
              { path: "errors/504-modern", permission: true, pageType: "view" },
              {
                path: "errors/504-classic",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Dashboard: {
            menuItem: "Dashboard",
            access: true,
            routes: [{ path: "dashboard", permission: true, pageType: "view" }],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          WorkBOQ: {
            menuItem: "Work BOQ",
            access: true,
            routes: [
              { path: "work-boq-list", permission: true, pageType: "view" },
              { path: "work-boq-creation", permission: true, pageType: "add" },
              {
                path: "work-boq-view/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "work-boq-approvals",
                permission: true,
                pageType: "approve",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          WorkRequest: {
            menuItem: "Work Request",
            access: true,
            routes: [
              { path: "work-request-list", permission: true, pageType: "view" },
              {
                path: "work-request-creation",
                permission: true,
                pageType: "add",
              },
              {
                path: "work-request-view/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "work-request-approvals",
                permission: true,
                pageType: "approve",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          WorkOrder: {
            menuItem: "Work Order",
            access: true,
            routes: [
              { path: "view-work-orders", permission: true, pageType: "view" },
              {
                path: "work-order-creation",
                permission: true,
                pageType: "add",
              },
              {
                path: "work-order-view/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "work-order-approvals",
                permission: true,
                pageType: "view",
              },
              {
                path: "Finalized-Work-Orders",
                permission: true,
                pageType: "view",
              },
              {
                path: "work-order-contractor-approvals",
                permission: true,
                pageType: "view",
              },
              {
                path: "view-work-order-details/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "work-order-riskflags/:id",
                permission: true,
                pageType: "add",
              },
              {
                path: "work-order-advance/:id",
                permission: true,
                pageType: "add",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          imports: {
            menuItem: "Imports",
            access: true,
            routes: [
              {
                path: "imports-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "create-import",
                permission: true,
                pageType: "add",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          payment: {
            menuItem: "Payment",
            access: true,
            routes: [
              {
                path: "create-payment",
                permission: true,
                pageType: "add",
              },
              {
                path: "pending-payment-approvals",
                permission: true,
                pageType: "approve",
              },
              {
                path: "run-payments",
                permission: true,
                pageType: "edit",
              },
              {
                path: "view-payments",
                permission: true,
                pageType: "view",
              },
              {
                path: "payment-analytics",
                permission: true,
                pageType: "view",
              },
              {
                path: "invoice-payables",
                permission: true,
                pageType: "view",
              },
              {
                path: "release-retention",
                permission: true,
                pageType: "view",
              },
              {
                path: "release-retention-form",
                permission: true,
                pageType: "add",
              },
              {
                path: "release-on-hold",
                permission: true,
                pageType: "view",
              },
              {
                path: "release-on-hold-form",
                permission: true,
                pageType: "add",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          receivable: {
            menuItem: "Receivables",
            access: true,
            routes: [
              {
                path: "view-receivables",
                permission: true,
                pageType: "view",
              },
              {
                path: "create-receivable",
                permission: true,
                pageType: "add",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          WorkExecution: {
            menuItem: "Work Execution",
            access: true,
            routes: [
              {
                path: "work-execution-under-execution",
                permission: true,
                pageType: "view",
              },
              {
                path: "work-execution-pending-approvals",
                permission: true,
                pageType: "approve",
              },
              {
                path: "work-execution-view/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "work-execution-batch-details/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "work-execution-update/:workOrderId",
                permission: true,
                pageType: "create",
              },
              {
                path: "work-execution-hold/:workOrderId",
                permission: true,
                pageType: "edit",
              },
              {
                path: "work-execution-release/:workOrderId",
                permission: true,
                pageType: "edit",
              },
              {
                path: "work-execution-closed-works",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Budget: {
            menuItem: "Work Budget",
            access: true,
            routes: [
              {
                path: "view-budget",
                permission: true,
                pageType: "view",
              },
              {
                path: "pendingApproval-budget",
                permission: true,
                pageType: "view",
              },
              {
                path: "new-budget",
                permission: true,
                pageType: "add",
              },
              {
                path: "view_budget_details/:budgetId",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          RABills: {
            menuItem: "RA Bills",
            access: true,
            routes: [
              {
                path: "ra-bills-new",
                permission: true,
                pageType: "add",
              },
              {
                path: "ra-bills-create",
                permission: true,
                pageType: "edit",
              },
              {
                path: "ra-bills-create-detail/:woId",
                permission: true,
                pageType: "edit",
              },
              {
                path: "ra-bills-pending-approvals",
                permission: true,
                pageType: "approve",
              },
              {
                path: "ra-bills-view-approved",
                permission: true,
                pageType: "view",
              },
              {
                path: "ra-bills-outstanding",
                permission: true,
                pageType: "view",
              },
              {
                path: "ra-bills-overdue",
                permission: true,
                pageType: "view",
              },
              {
                path: "ra-bills-view-details/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "ra-bills-approval-details/:id",
                permission: true,
                pageType: "approve",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          WorkOrderReports: {
            menuItem: "Work Order Reports",
            access: true,
            routes: [
              {
                path: "work-order-reports",
                permission: true,
                pageType: "view",
              },
              {
                path: "work-order-reports/contractor-ledger",
                permission: true,
                pageType: "view",
              },
              {
                path: "work-order-reports/:reportId",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
        };
        console.log("decodedString", decodedString);
        const decodedData = decodedString;
        console.log("decodedData", decodedData);
        dispatch(updateAccessibility(decodedData));
        const _allowedRoutes = [];
        const _restrictedRoutes = [];
        Object.keys(decodedData).forEach((mod) => {
          const module = decodedData[mod];
          if (module?.access) {
            module?.routes?.forEach((route) => {
              if (route?.permission) {
                _allowedRoutes.push(route?.path);
              } else {
                _restrictedRoutes.push(route?.path);
              }
            });
          }
        });
        setAccessibility(_allowedRoutes);
        setRestrictedRoutes(_restrictedRoutes);
        const _menu = [];
        menu?.forEach((item) => {
          if (item?.subMenu?.length > 0) {
            const subMenu = [];
            item?.subMenu?.forEach((subItem) => {
              if (subItem?.subMenu?.length > 0) {
                const _subMenuChildren = [];
                subItem?.subMenu?.forEach((subSubItem) => {
                  if (_allowedRoutes.includes(subSubItem?.link)) {
                    _subMenuChildren.push({
                      text: subSubItem?.text,
                      link: subSubItem?.link,
                      icon: subSubItem?.icon,
                    });
                  }
                });
                if (_subMenuChildren.length > 0) {
                  subMenu.push({
                    text: subItem?.text,
                    icon: subItem?.icon,
                    active: false,
                    subMenu: _subMenuChildren,
                  });
                }
                return;
              }
              if (_allowedRoutes.includes(subItem?.link)) {
                subMenu.push({
                  text: subItem?.text,
                  icon: subItem?.icon,
                  link: subItem?.link,
                });
              } else {
                if (subItem?.alt?.length > 0) {
                  const altLink = subItem?.alt?.find((link) =>
                    _allowedRoutes.includes(link)
                  );
                  if (altLink) {
                    subMenu.push({
                      text: subItem?.text,
                      icon: subItem?.icon,
                      link: altLink,
                    });
                  }
                }
              }
            });
            if (subMenu.length > 0) {
              _menu.push({
                text: item?.text,
                subMenu: subMenu,
                icon: item?.icon,
              });
            }
          } else {
            if (_allowedRoutes.includes(item?.link)) {
              _menu.push({
                text: item?.text,
                link: item?.link,
                icon: item?.icon,
              });
            } else if (item?.alt?.length > 0) {
              const altLink = item?.alt?.find((link) =>
                _allowedRoutes.includes(link)
              );
              if (altLink) {
                _menu.push({
                  text: item?.text,
                  icon: item?.icon,
                  link: altLink,
                });
              }
            }
          }
        });
        if (!_allowedRoutes?.includes("dashboard")) {
          _menu.unshift({
            text: "",
            link: "home",
            icon: <HomeOutlined style={{ fontSize: "18px" }} />,
          });
        }
        dispatch(updateMenuData(_menu));
        dispatch(updateAllowedRoutes(_allowedRoutes));
      } catch (error) {
        console.log("error", error);
      }
    }
  }, [currentUser]);

  useEffect(() => {
    const isAuthenticated = Cookies.get("access-token");
    if (!isAuthenticated && !globalRoutes?.includes(window.location.pathname)) {
      window.location.href = "/";
    }
  }, []);

  return (
    <Routes>
      <Route path={`${process.env.PUBLIC_URL}`} element={<Layout />}>
        <Route path="home" element={<DefaultDashboardPage />} />
        {accessibility?.map(
          (path) =>
            routesMap[path] && (
              <Route key={path} path={path} element={routesMap[path]} />
            )
        )}
        {restrictedRoutes?.map((path) => (
          <Route path={path} element={<div> Unauthorized Access</div>} />
        ))}
        <Route path="notifications" element={<NotificationMain />} />
        <Route path="privacy" element={<Faq />}></Route>
        <Route
          path="user-profile-regular"
          element={<UserProfileRegular />}
        ></Route>
        <Route
          path="user-profile-notification"
          element={<UserProfileNotification />}
        ></Route>
        <Route
          path="user-profile-activity"
          element={<UserProfileActivity />}
        ></Route>
        <Route
          path="excelexport-requested-list"
          element={<ExcelExportRequestedList />}
        ></Route>
        <Route path="bulk-upload-list" element={<BulkUploadList />}></Route>
        <Route
          path="user-profile-setting"
          element={<UserProfileSetting />}
        ></Route>
      </Route>

      <Route path={`${process.env.PUBLIC_URL}`} element={<LayoutNoSidebar />}>
        <Route path="auth-reset" element={<ResetPassword />}></Route>
        <Route path="auth-success" element={<Success />}></Route>
        <Route path="auth-register" element={<Register />}></Route>
        <Route path="success" element={<SuccessMain />}></Route>
        <Route index element={<Login setIsLoggedIn={setIsLoggedIn} />}></Route>

        <Route
          path="*"
          element={
            accessibility.length === 0 ? (
              <>
                <Flex align="center" gap="middle" className="pageLoader">
                  <Spin size="large" className="m-auto" />
                </Flex>
              </>
            ) : (
              <Error404Modern />
            )
          }
        ></Route>
      </Route>
    </Routes>
  );
};
export default Pages;
